import { render, staticRenderFns } from "./emergencyMeasure.vue?vue&type=template&id=ced23014&scoped=true"
import script from "./emergencyMeasure.vue?vue&type=script&lang=js"
export * from "./emergencyMeasure.vue?vue&type=script&lang=js"
import style0 from "./emergencyMeasure.vue?vue&type=style&index=0&id=ced23014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced23014",
  null
  
)

export default component.exports